import { useContext } from "react";
import { AuthContext } from "../../../../../../context/context";
import { DataGrid } from "../../../../../../shared/components";
import { AltaContext, EndosoContext } from "../../../../context";
import { useColumns } from "../hooks";

export const TitularesTable = () => {
  const columns = useColumns();
  const { setTimer } = useContext(AuthContext);
  const { titulares, openModal } = useContext(AltaContext);
  const { createMessage } = useContext(EndosoContext);

  const handleClick = ({ row }) => {
    setTimer(0);
    if (row.familiares < 9) openModal(row);
    else
      createMessage({
        text: "No se pueden agregar mas de 9 asociados por titular",
        variant: "warning",
      });
  };
  return (
    <DataGrid
      columns={columns}
      rows={titulares}
      id="id"
      onCellClick={handleClick}
    />
  );
};
